import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, filter, tap } from 'rxjs';
import { TrackByPropertyPipe } from 'src/app/core/pipes/track-by-property.pipe';
import {
  Popup,
  PopupToasterService,
  PopupType
} from 'src/app/core/services/popup-toaster.service';

@Component({
  selector: 'message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.sass'],
  standalone: true,
  imports: [CommonModule, TrackByPropertyPipe]
})
export class MessagePopupComponent implements OnInit, OnDestroy {
  popups: Popup[] = [];
  src = '';

  private _subscription: Subscription = new Subscription();

  constructor(private _popupToasterService: PopupToasterService) {}

  private _addNotification(popup: Popup) {
    this.popups.push(popup);
  }

  ngOnInit() {
    this._subscription = this._popupToasterService
      .getObservable()
      .pipe(
        tap((popup) => this._addNotification(popup)),
        filter((popup) => !!popup.timeout),
        tap((popup) => {
          setTimeout(() => {
            this.close(popup);
          }, popup.timeout);
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  close(popup: Popup) {
    this.popups = this.popups.filter((notif) => notif.id !== popup.id);
  }

  className(popup: Popup): string {
    let style = '';

    switch (popup.type) {
      // TODO: Active in the future if we need it!
      case PopupType.success:
        style = 'success';
        this.src = 'assets/icons/GRN_CircleCheckmark.svg';
        break;

      case PopupType.error:
        style = 'error';
        this.src = 'assets/icons/timeout-icon.svg';
        break;

      default:
        break;
    }

    return style;
  }
}
